import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import Service from '../../store/service'

export const getIndustry = createAsyncThunk(
  'portfolioInsights/segment/portfolioIndustry/getIndustry',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getIndustry(params)

      if (response.success) return response.data

      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportIndustry = createAsyncThunk(
  'portfolioInsights/segment/portfolioIndustry/exportIndustry',
  async (params) => {
    const response = await Service.exportIndustry(params)
    handleExport(response.data, response.filename)
  },
)
